import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { withRouter } from 'react-router-dom'

// const ComplianceCard = this.props => {
class ComplianceCard extends React.Component {
  render () {
    let classes = ''
    if (this.props.hoverColor) {
      classes += ' card-hover control '
    }
    if (this.props.isActive) {
      classes = 'compliance-card-active '
    }
    let { cardWidth } = this.props
    return (
      // `${this.props.width ? this.props.width : 350}`
      <Card
        style={{ width: (cardWidth || 350) }}
        id={this.props.id}
        className={` ${this.props.clickable ? 'pointer-element' : ''}`}
      >
        <CardBody className={` ${classes + this.props.bgColor}`}
          onClick={() => {
            if (this.props.clickable) {

              this.props.setUpdate(this.props.category, this.props.selectedCatName.name)
              this.props.changeCategory(this.props.id, this.props.category.toLowerCase())
              // this.props.history.push(`?category=${slugify(this.props.category).toLowerCase()}`)
            }
            // return this.props.clickable ?  : null
          }}>
          {
            this.props.title
              ? <h3>{this.props.title.substring(0, 38) + (this.props.title.length > 38 ? '...' : '')}</h3>
              : this.props.category
                ? <h4 style={{ height: 30, marginBottom: 15 }}>
                  {this.props.category.substring(0, 38) + (this.props.category.length > 38 ? '...' : '')}
                </h4>
                : null
          }
          {this.props.safeguardID ?
            <span>{this.props.safeguardID}</span>
            : null}
          {this.props.isPercentage ?
            <div
              style={Object.assign({
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
              }, this.props.styles ? this.props.styles : {})}>
              {this.props.totalControls > 0 ?
                <React.Fragment>
                  <div style={{
                    fontSize: 50,
                    color: this.props.percentage_color,
                    paddingRight: 20
                  }}>{typeof this.props.percentage === 'number' ? this.props.percentage : 0}%</div>
                  <div style={{
                    fontSize: 16,
                    fontWeight: 200,
                    paddingLeft: 50,
                    color: 'grey',
                    borderLeft: '2px solid #D9DBDC'
                  }}> {`${this.props.numberCompliance || 0} of ${this.props.totalControls} tasks completed`}</div>
                </React.Fragment>
                :
                <React.Fragment>
                  <div style={{
                    fontSize: 50,
                    color: this.props.percentage_color,
                    paddingRight: 20
                  }}>N/A</div>
                  <div style={{
                    fontSize: 16,
                    fontWeight: 200,
                    paddingLeft: 50,
                    color: 'grey',
                    borderLeft: '2px solid #D9DBDC'
                  }}> {`${this.props.numberCompliance || 0} of ${this.props.totalControls} tasks completed`}</div>
                </React.Fragment>
              }

            </div> : null}
        </CardBody>
      </Card >
    )
  }
}

export default withRouter(ComplianceCard)



// WEBPACK FOOTER //
// ./src/components/compliance/components/compliance-card.js